import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { AppColors } from '../Utils/helper/AppColors';
import { ArrowDownIcon } from './Icons/Icons';
import { getColorSettings } from '../Utils/helper/commonUtils';

export default function CustomAutoComplete({
	label,
	options = [],
	value,
	onChange,
	setOptions,
	placeholder,
	InputLabelProps,
	multiple = false,
	//   disableClearable = false,
	// freeSolo = false,
	sx,
	...rest
}) {
   
	// Convert value to appropriate format
	const formattedValue = React.useMemo(() => {
		if (multiple) {

			// For multiple selection mode
			if (!value || value.length === 0) return [];
			
			// If value is already an array of objects with label/value properties
			if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'object' && 'value' in value[0]) {
				console.log('value1 running');
				return value;
			}
			
			// If value is an array of strings/values, convert to objects matching option format
			// if (Array.isArray(value)) {
			// 	console.log('value2 running');
			// 	return value.map(val => {
			// 		// Try to find matching option
			// 		const matchingOption = options.find(opt => opt.value === val);
			// 		return matchingOption || { label: String(val), value: val };
			// 	});
			// }
			
			// If value is a single object
			if (typeof value === 'object' && value !== null && 'value' in value) {
				console.log('value3 running');
				return [value];
			}
			
			// If value is a single primitive value
			return [{ label: String(value), value }];
		}
		
		// For single selection
		if (!value) return '';
		
		// If already an object with label/value
		if (typeof value === 'object' && value !== null && 'value' in value) {
			return value;
		}
		
		// Try to find matching option
		const matchingOption = options.find(opt => opt.value === value);
		return matchingOption || { label: String(value), value };
	}, [value, multiple, options]);
	
	const localSettingColors = getColorSettings();

	return (
		<Autocomplete
			multiple={multiple}
			// freeSolo={freeSolo}
			// disableClearable={disableClearable}
			fullWidth
			options={options}
			popupIcon={<ArrowDownIcon color={localSettingColors.buttonBackground} size={11} />}
			value={formattedValue}
			onChange={(event, newValue) => {
				console.log('CustomAutoComplete onChange newValue:', newValue);
				
				// Handle the onChange event based on multiple mode
				if (multiple) {
					// For multiple mode, newValue will be an array of objects
					// We want to preserve the full objects with label/value
					onChange(newValue || []);
				} else {
					// For single mode
					onChange(newValue || '');
				}
				
				// Handle dynamic options if needed
				if (setOptions && newValue && !Array.isArray(newValue) && 
					typeof newValue === 'object' && !options.some(opt => opt.value === newValue.value)) {
					setOptions([...options, newValue]);
				}
			}}
			renderInput={(params) => (
				<TextField
					{...params}
					label={label}
					placeholder={placeholder}
					size="small"
					fullWidth
					InputLabelProps={{
						// shrink: true,
						sx: {
							color: AppColors.HEADING_TITLE4,
							fontSize: '12px',
							fontWeight: '400',
							// lineHeight: '115%',
							fontFamily: 'Poppins',
							...(InputLabelProps?.sx || {}),
						},
						...InputLabelProps,
					}}
					sx={{
						'& .MuiOutlinedInput-root': {
							'& fieldset': {
								borderColor: '#ECE7FC',
								borderRadius: '10px',
							},
							'&:hover fieldset': {
								borderColor: '#ECE7FC',
								borderRadius: '10px',
							},
							'&.Mui-focused fieldset': {
								borderColor: '#ECE7FC',
								borderRadius: '10px',
							},
							'& .MuiInputBase-input': {
										paddingTop: '7.5px',
										paddingBottom: '7.5px', // <-- Add this line
									},
						},
						...sx,
					}}
				/>
			)}
			{...rest}
		/>
	);
}
